import { createBrowserHistory } from 'history';

// Create and export a single instance of history object to share.
const history = createBrowserHistory();
export default history;
